<div style="padding: 5px; margin: 20px; min-width: 1024px; vertical-align: top;">
  <h2>Rapoty e-Walidacji</h2>
  <ng-container *ngIf="validatorProviders && validatorProviders.length > 0">
    <div class="ui-g ui-fluid">
      <div class="ui-g-6">
        <label>Posiadacz walidatora:</label>
        <p-dropdown [options]="validatorProviders"
                    [(ngModel)]="queryRequest.validatorProviderId"
                    showClear="true"
                    placeholder="Wybierz posiadacza walidatora">
        </p-dropdown>
      </div>
      <div class="ui-g-6">
        <label>Data od:</label>
        <p-calendar [(ngModel)]="queryRequest.dateFrom"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    hourFormat="24"
                    [showButtonBar]="false"
                    [showIcon]="true"
                    [locale]="pl">
        </p-calendar>
      </div>
      <div class="ui-g-6">
        <label>Data do:</label>
        <p-calendar [(ngModel)]="queryRequest.dateUntil"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    hourFormat="24"
                    [showButtonBar]="false"
                    [showIcon]="true"
                    [locale]="pl">
        </p-calendar>
      </div>
      <div class="ui-g-12">
        <p-button class="button" routerLink='/' label="Zamknij"></p-button>
        <p-button class="button" (click)="generateReport()" label="Generuj"></p-button>
        <p-button class="button" (click)="downloadReport()" label="Pobierz raport"></p-button>
      </div>
    </div>
    <hr />
    <p-table [value]="report" [paginator]="true" [rows]="30">
      <ng-template pTemplate="header">
        <tr style="white-space: nowrap;">
          <th>Id posiadacza walidatora</th>
          <th>Posiadacz walidatora</th>
          <th>Konfiguracja walidacji</th>
          <th>Czas walidacji</th>
          <th>Numer transakcji</th>
          <th>Upust nominalnie</th>
          <th>Upust proporcjonalnie</th>
          <th>Pozostała kwota</th>
          <th>Osoba walidująca</th>
          <th>Dodatkowe informacje</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr style="white-space: normal; overflow-wrap: break-word;">
          <td>{{item.id.validatorProviderId}}</td>
          <td>{{item.validatorProviderName}}</td>
          <td>{{item.validationConfigName}} ({{item.id.validationConfigId}})</td>
          <td>{{item.id.validationTime | date:'yyyy-MM-dd HH:mm:ss'}}</td>
          <td>{{item.id.transactionNumber}}</td>
          <td>{{item.rateReduction}}</td>
          <td>{{item.rateReductionProp}}</td>
          <td>{{item.openAmount}}</td>
          <td>{{item.username}}</td>
          <td>{{item.additionalInfo}}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</div>
